import api from './api';
import auth from './auth';
import transactionReportWorker from './transaction-report'
import alarmWorker from './alarm'

export default [api, auth, transactionReportWorker, alarmWorker];
